import React, { useState } from "react";
import { MOCK_DEPARTMENTS, MOCK_EMBED_FORMS } from "./mockData";

const FIELD_TYPES = [
    { value: "text", label: "Text" },
    { value: "email", label: "Email" },
    { value: "textarea", label: "Long text" },
];

const defaultFields = [
    { id: 1, type: "text", label: "Full name", required: true },
    { id: 2, type: "email", label: "Email", required: true },
    { id: 3, type: "textarea", label: "Message", required: true },
];

const MockEmbedForms = ({ departments = MOCK_DEPARTMENTS }) => {
    const [formName, setFormName] = useState("Contact Form");
    const [department, setDepartment] = useState(departments[0]?.name || "");
    const [fields, setFields] = useState(defaultFields);
    const [nextId, setNextId] = useState(4);

    const addField = () => {
        setFields((prev) => [
            ...prev,
            { id: nextId, type: "text", label: "New field", required: false },
        ]);
        setNextId((n) => n + 1);
    };

    const updateField = (id, key, value) => {
        setFields((prev) => prev.map((f) => (f.id === id ? { ...f, [key]: value } : f)));
    };

    const removeField = (id) => {
        setFields((prev) => prev.filter((f) => f.id !== id));
    };

    return (
        <div className="clk-mk-embed">
            <div className="clk-mk-page-head">
                <h4>Embed Ticket Forms</h4>
            </div>
            <div className="clk-mk-embed-layout">
                <div className="clk-mk-embed-editor clk-mk-scroll-pane">
                    <p className="clk-mk-embed-label">Existing forms</p>
                    <ul className="clk-mk-embed-list">
                        {MOCK_EMBED_FORMS.map((f) => (
                            <li key={f.id}>
                                <strong>{f.name}</strong>
                                <span>{f.department} · {f.submissions} submissions</span>
                            </li>
                        ))}
                    </ul>

                    <p className="clk-mk-embed-label">Create a simple form</p>
                    <label className="clk-mk-field">
                        <span>Form name</span>
                        <input
                            type="text"
                            value={formName}
                            onChange={(e) => setFormName(e.target.value)}
                        />
                    </label>
                    <label className="clk-mk-field">
                        <span>Department</span>
                        <select value={department} onChange={(e) => setDepartment(e.target.value)}>
                            {MOCK_DEPARTMENTS.map((d) => (
                                <option key={d.id} value={d.name}>{d.name}</option>
                            ))}
                        </select>
                    </label>

                    <div className="clk-mk-embed-fields">
                        <div className="clk-mk-embed-fields-head">
                            <span>Fields</span>
                            <button type="button" className="clk-mk-link-btn" onClick={addField}>
                                + Add field
                            </button>
                        </div>
                        {fields.map((field) => (
                            <div key={field.id} className="clk-mk-embed-field-row">
                                <select
                                    value={field.type}
                                    onChange={(e) => updateField(field.id, "type", e.target.value)}
                                >
                                    {FIELD_TYPES.map((t) => (
                                        <option key={t.value} value={t.value}>{t.label}</option>
                                    ))}
                                </select>
                                <input
                                    type="text"
                                    value={field.label}
                                    onChange={(e) => updateField(field.id, "label", e.target.value)}
                                    placeholder="Field label"
                                />
                                <label className="clk-mk-check-inline">
                                    <input
                                        type="checkbox"
                                        checked={field.required}
                                        onChange={(e) => updateField(field.id, "required", e.target.checked)}
                                    />
                                    Required
                                </label>
                                {fields.length > 1 && (
                                    <button
                                        type="button"
                                        className="clk-mk-icon-btn"
                                        onClick={() => removeField(field.id)}
                                        aria-label="Remove field"
                                    >
                                        ×
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="clk-mk-embed-preview clk-mk-scroll-pane">
                    <p className="clk-mk-embed-label">Preview</p>
                    <div className="clk-mk-embed-preview-card">
                        <h5>{formName || "Untitled form"}</h5>
                        <p className="clk-mk-embed-preview-sub">We usually reply within one business day.</p>
                        {fields.map((field) => (
                            <label key={field.id} className="clk-mk-preview-field">
                                <span>
                                    {field.label}
                                    {field.required && " *"}
                                </span>
                                {field.type === "textarea" ? (
                                    <textarea rows={3} placeholder={field.label} readOnly />
                                ) : (
                                    <input type={field.type} placeholder={field.label} readOnly />
                                )}
                            </label>
                        ))}
                        <button type="button" className="clk-mk-preview-submit">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MockEmbedForms;
